import { Component, OnInit, Input } from "@angular/core";
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: "app-natureza-disciplinar",
  templateUrl: "./natureza-disciplinar.component.html",
  styleUrls: ["./natureza-disciplinar.component.css"]
})
export class NaturezaDisciplinarComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;
  nomeCartorio = null;
  classificacaoNenhumaOpcaoAnteriorId = 63;
  CLASSIFICACAO_SERVIDOR_INTERIOR = 39;
  isServidorInterior: boolean = false;

  constructor(
    public service: ReclamacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListas();

    if (!this.visualizacao && !this.edicao) {

      this.service.reclamacao.controls.descricaoReclamacao.setValue('');

    }

    if (this.visualizacao || this.edicao) {

      if(this.service.reclamacao.controls.listaClassificacao.value.length === 1){
       let classificacaoItem = this.service.reclamacao.controls.listaClassificacao.value[0];
       this.marcarCheckClassificacaoEdicaoVisualizacao(classificacaoItem);
      }

    }
 }

  preencherListas() {

    // Obtendo a classificação Nenhuma das opções anteriores, para ser inserido por ultimo na listagem
    //TODO Deverá se verificado uma forma de transformar a classificação Nenhuma das opções anteriores como
    // o ultimo item de qualquer busca por classificação. Ocorrendo problema ao montar a lista, a mesma é reordenada e perde modificação feita no
    // backend.
    var ultimoItemClassificacao = this.service.reclamacao.value.listaClassificacaoCompleta
      .find(item => item.id === this.classificacaoNenhumaOpcaoAnteriorId);

    this.listaClassificacaoComponente = this.service.reclamacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.reclamacao.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId);

      this.listaClassificacaoComponente.push(ultimoItemClassificacao);
      //console.log('Lista classificacao natureza disciplinar', this.listaClassificacaoComponente);
  }

  checkClassificacao(item) {

    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao(item);

  }

  // Método de funcionamento para Radio Button
  checkClassificacaoUmRegistro(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao(item);
    this.marcarCheckClassificacaoInclusao(item);
    //console.log('Valor do item =>', item);
    //console.log('Valor da lista =>', this.service.denuncia.controls.listaClassificacao.value);
  }

  marcarCheckClassificacaoEdicaoVisualizacao(item: any) {
    this.marcarCheckClassificacao(item, false);
  }

  marcarCheckClassificacaoInclusao(item: any) {
    this.marcarCheckClassificacao(item, true);
  }


  marcarCheckClassificacao(item: any, isInclusaoRegistro: boolean) {

    if(isInclusaoRegistro){
      this.limparCampos();
    }

    if(item.id === this.CLASSIFICACAO_SERVIDOR_INTERIOR){
      this.preencheInformacoesServidorInterior();

    }else{
      this.preencheInformacoesOutrasClassificacoes();
    }
  }

  atribuirListaClassificacao(item) {

    const novaLista = this.listaClassificacaoComponente.filter(lcc => lcc.selecionado);
    novaLista.forEach(c => {

      if (c.id === 39 && c.id !== item.id) {

        const selecionado = c.selecionado;
        const classificacao = this.service.reclamacao.controls.listaClassificacao.value.find(cl => cl.id === c.id);
        c.unidade = classificacao.unidade;
        c.selecionado = selecionado;

      }

    });

    this.service.reclamacao.controls.listaClassificacao.setValue(novaLista);

  }

  contemErro(str) {
    return this.service.reclamacao.controls[str].touched &&
      this.service.reclamacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  changeUnidade(item) {
    this.service.reclamacao.controls.listaClassificacao.value.find(each => each.id == item.id).unidade =
      this.service.reclamacao.value.unidadeAux;
  }

  isCheckedServidorInterior(){
    return this.isServidorInterior;
  }

  preencheInformacoesServidorInterior() {
    this.isServidorInterior = true;
  }

  selecionaComarca(){
    var codigoComarca = this.service.reclamacao.controls.codigoComarca.value;
    this.service.reclamacao.controls.codigoComarca.setValue(codigoComarca);
    // var codigoMunicipio = this.service.reclamacao.controls.codigoMunicipio.value;
    // this.service.reclamacao.controls.codigoComarca.setValue(codigoMunicipio);
  }

  limparCampos(){
    //this.service.reclamacao.controls.codigoMunicipio.setValue('');
    this.service.reclamacao.controls.codigoComarca.setValue('');
  }

  preencheInformacoesOutrasClassificacoes() {
    this.isServidorInterior = false;
  }

}
